module.exports = __webpack_public_path__ + "static/media/share-grey.5ec1b8dc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/icons/share-grey.svg
// module id = 1941
// module chunks = 0